<template>
  <ul class="headerLangDropdown">
    <li
      v-for="(lang, index) in unselectedLanguages"
      :key="index"
      class="headerLangDropdown__item"
    >
      <button
        class="headerLangDropdown__link"
        :class="{
          'headerLangDropdown__link--selected': currentLang === lang[0],
        }"
        @click="setLang(lang[0])"
      >
        <span
          class="headerLangDropdown__flag flag"
          :class="`flag--${lang[0]}`"
        />
        <span class="headerLangDropdown__lang"> {{ lang[1] }}</span>

        <gl-svg-icon v-if="currentLang === lang[0]" icon="tick" />
      </button>
    </li>
  </ul>
</template>

<script>
import { languages } from '@/config'
import { EventBus } from '@/event-bus'
import { refreshPage } from '@/mixins'
import GlSvgIcon from '@/shared/GlSvgIcon'

export default {
  name: 'BaseHeaderLangDropdown',
  mixins: [refreshPage],
  components: { GlSvgIcon },
  props: {
    currentLang: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      languages,
    }
  },
  computed: {
    unselectedLanguages() {
      return Object.entries(this.languages)
    },
  },
  mounted() {
    const fnDClick = (name) => {
      if (name !== 'lang') this.$emit('close')
    }
    EventBus.$on('d-click', fnDClick)
    this.$once('hook:beforeDestroy', () => {
      EventBus.$off('d-click', fnDClick)
    })
  },
  methods: {
    setLang(selectedLang) {
      this.$i18n.locale = selectedLang
      this.$router.push({
        name: this.$route.name,
        params: { locale: selectedLang },
      })
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/flag';

.headerLangDropdown {
  @media (min-width: $breakpoint-md) {
    border-radius: 4px;
    display: flex;
    //flex-direction: column;
    flex-wrap: wrap;
    //height: 480px;
    overflow: hidden;
    //width: 392px;
    width: 376px;
    flex-direction: row;
  }

  &__item {
    @media (min-width: $breakpoint-md) {
      //width: 50%;
      width: 188px;
    }
  }

  &__lang {
    flex: 1;
  }

  &__link {
    @include text-subtitle-3;

    align-items: center;
    border-radius: 4px;
    color: inherit;
    display: flex;
    outline: none;
    padding: 12px 16px;
    text-align: left;
    width: 100%;

    @media (min-width: $breakpoint-md) {
      border-radius: 0;
      padding: 12px 16px 12px 16px;
    }

    &:hover {
      background-color: $color-primary;
      color: #fff;
    }

    &--selected {
      color: $color-primary;
      background-color: $color-gray-6;
    }
  }

  &__flag {
    flex-shrink: 0;
    margin-right: 16px;
  }
}
</style>
